import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="time-preview"
export default class extends Controller {
  static targets = ['hourField', 'minuteField', 'ampmField', 'timeZoneField', 'previewField']

  connect () {
    console.log('time-preview controller connected')
  }

  update (_event) {
    const hour = this.hourFieldTarget.value
    const minute = this.minuteFieldTarget.value.padStart(2, '0')
    const ampm = this.ampmFieldTarget.value

    const preview = `${hour}:${minute} ${ampm}`

    this.previewFieldTarget.value = preview
    this.previewFieldTarget.dispatchEvent(new Event('change', { bubbles: true }))
  }
}
